export const countriesQuery = gql`
    query Countries {
        countries(filter: { isEea: true }) {
            alpha2Code
        }
    }
`
